export const ContractStatus = {
  new: { color: "red-vito" },
  sent: { color: "green-vito" },
  canceled: { color: "red-vito" },
};
